import type {MRT_ColumnDef} from "material-react-table";

export const TABLE_DEFAULT_PAGE_SIZE = 50;
export const TABLE_DEFAULT_PAGE_INDEX = 0;
const safeAccessor = (key: string) => (row: any) => {
  return row?.[key] ?? "";
};
/*************************************************************************************
 * Reusable component used for the main tables on the Argos site
 *
 * They include headers, extra toolbar functionality, and basic functionality found
 * throughout all tables such as column actions, filters, sorting, resizing
 *************************************************************************************/

export const argosFilteringOptions = ["between",
  "betweenInclusive", "contains", "empty", "endsWith",
  "equals", "greaterThan", "greaterThanOrEqualTo", "lessThan",
  "lessThanOrEqualTo", "notEmpty", "notEquals", "startsWith"]
export const postProcessColumns = (unprocessedColumns: any) => {
  const processedColumns: any[] = []
  unprocessedColumns.forEach((column: MRT_ColumnDef<any>) => {
    const newCol = {
      ...column,
      filterFn: "contains",
      accessorFn: column.accessorFn ?? safeAccessor(column.accessorKey ?? '')
    }
    processedColumns.push(newCol)
  })
  return processedColumns
}